import { Container, Button,Alert,Table, Modal, Col, Row , Form} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "./ContentStyles";

import { FaFilePdf, FaReceipt, FaEnvelope,FaBars, FaCog } from 'react-icons/fa';
import useBackend, {CallAPI, CallAPIGet, Loading, SpinnerX, IsLoggedIn} from '../services/useBackend';
import React, {useMemo, useState, useEffect } from 'react';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import {Branding, DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, AddTimezoneOffset} from '../services/misc';

export default function MyComponent() {
    const [resultText,    setResultText]    = useState(":)");
    const [resultVariant, setResultVariant] = useState("notset");
    const [resultVisible, setResultVisible] = useState(false);
    const [spinnerHidden, setSpinnerHidden] = useState(true);

    const {loading, data, Refresh} =  useBackend('/api/admin/shops');

    var {loggedIn, isAdmin, isSuperUser, userName, accountIsLocked} = IsLoggedIn();

    const [modalshow,  setModalshow] = useState(false);    
    const initModal = () => { return setModalshow(!modalshow) } 

    const [modalshowAddShop,  setModalshowAddShop] = useState(false);    
    const initModalAddShop = () => { return setModalshowAddShop(!modalshowAddShop) }     

    const [selectedShopData, setSelectedShopData]   = useState({Name:"...", OpeningHoursUTCStart:"00:00:00", OpeningHoursUTCEnd:"00:00:00", EntryCode:{Code:""}});
    const [selectedShopState, setSelectedShopState] = useState({ConnectionState:"Ej tillgänglig",ConnectionStateColor:"#F00", DoorState:"Ej tillgänglig", Temperature:"Ej tillgänglig"});  

    const navigate = useNavigate();

    if (accountIsLocked) navigate("/instance/invoices");

    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });

    useEffect(() => { navigate('?pageindex='+pagination.pageIndex+'&pagesize='+pagination.pageSize) }, [pagination]);

    const detailShopClick = async (event, rowData)  =>  {

        setSelectedShopData(rowData.original)
        setModalshow(!modalshow);
        var LockState = {ConnectionState:"Hämtar info", DoorState:"Ej tillgänglig", Temperature:"Ej tillgänglig"};
        
        console.log(rowData.original.Guid);
        let {resultVariant, resultVisible, resultText, jsondata} = await CallAPIGet('/api/admin/shop/'+rowData.original.Guid+'/GetState',"GET");

        if (jsondata.LockState.online) {
            LockState.ConnectionStateColor = "#24a33d";
            LockState.ConnectionState ="Online";
            LockState.DoorState =jsondata.LockState.lockState;
        } else {
            LockState.ConnectionStateColor = "#F00";
            LockState.ConnectionState ="Offline";
            LockState.DoorState ="Ej tillgänglig";
        }
        
        setSelectedShopState(LockState);
    }

    const editShopClick = (event)  =>  {
        const ShopGUID = event.currentTarget.getAttribute("shopguid");
        event.preventDefault();
        navigate("/shop/" + ShopGUID);
    }

    const addShopHandler = (event)  =>  {
        event.preventDefault();
        initModalAddShop();

        //navigate("/shop/add");
    }
    
    const handleClaimSubmit = async (e) =>{
        e.preventDefault();

        //setSaving(true);
        setResultText("");
        setResultVisible(false);
        const ShopForm = document.getElementById('AddShopForm');
        const formData = new FormData(ShopForm);
        const formDataObj = Object.fromEntries(formData.entries());

        let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/admin/shop', 'POST', JSON.stringify(formDataObj));

        setResultVariant(resultVariant);   
        setResultText(resultText);
        setResultVisible(resultVisible);

        setResultVisible(true);

        if (errorsException==false) initModalAddShop();
        Refresh();
    }      
    
    const columns = useMemo(() => [
        { size: 20, accessorKey: 'Name',        header: '#', enableColumnActions: false, enableHiding:false },
        { size: 100, accessorKey: 'Description', header: 'Description' },
        { size: 100, accessorKey: 'Company',     header: 'Company', headerClassName: 'test_'},                  
      ]
    );  

    const initialState = 
    { 
        density: 'compact',
        columnVisibility: { Company: false, Description:true }, 
        pagination : pagination 
    };  

    const state = { pagination : pagination };      

    async function unLockShop(event){
        const ShopGUID = event.currentTarget.getAttribute("shopguid");
        let {resultVariant, resultVisible, resultText} = await CallAPI('/api/admin/shop/'+ShopGUID+'/unlock',"PUT");	
    
        await setTimeout(5000);
    }


    



    if (!loading) {
        return (
            <ContentWrapper>

                <Modal show={modalshowAddShop} onHide={initModalAddShop}>
                    <Modal.Header closeButton>
                        <Modal.Title>Skapa ny butik</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form onSubmit={handleClaimSubmit} id="AddShopForm">

                            <Form.Group className="mb-3" >
                                    <Form.Label>Namn på butiken/kylskåpet</Form.Label>
                                    <Form.Control type="text" name ="Name" placeholder="Ange namn på butiken/kylskåpet" />                            
                            </Form.Group>

                            <Form.Group className="mb-3" >
                                    <Form.Label>ID på låsmodul/kylskåp</Form.Label>
                                    <Form.Control type="text" name ="LockId" placeholder="" />                            
                            </Form.Group>      

                            <Form.Group className="mb-3"  hidden={!loading}>
                                <SpinnerX  />
                            </Form.Group>                                      
                                
                            <Form.Group className="mb-3"  hidden={!resultVisible}>
                                <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                            </Form.Group>                        

                            <Form.Group className="mb-3">
                                                              
                            </Form.Group>                                        
                        </Form>                      
                    </Modal.Body>
                    
                    <Modal.Footer>

                    <Button className="QmeButton_" variant="secondary" type="submit" onClick={initModalAddShop}>Avbryt</Button>  
                    <Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="warning" type="submit" onClick={handleClaimSubmit}>Skapa butiken</Button>  
                    </Modal.Footer>
                </Modal>

                <Modal show={modalshow} onHide={initModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedShopData.Description} ({selectedShopData.Name})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>Företag</Col><Col>{selectedShopData.Company}</Col>                        
                        </Row>
                        <Row>
                            <Col>Minsta ålder</Col><Col>{selectedShopData.MinCustomerAge}</Col>                        
                        </Row>
                        <Row>
                            <Col>Öppettider</Col><Col>{SplitoutLocalTimeFromISO(selectedShopData.OpeningHoursUTCStart)}&nbsp; till &nbsp;{SplitoutLocalTimeFromISO(selectedShopData.OpeningHoursUTCEnd)}</Col>                        
                        </Row>

                        <Row>
                            <Col>Uppkoppling</Col><Col><font color={selectedShopState.ConnectionStateColor}><b>{selectedShopState.ConnectionState}</b></font></Col>                        
                        </Row>

                        <Row>
                            <Col>Dörr</Col><Col>{selectedShopState.DoorState}</Col>                        
                        </Row>

                        <Row>
                            <Col>Temperatur</Col><Col>{selectedShopState.Temperature}</Col>                        
                        </Row>                          

                        <Row>
                            <Col>EntryCode</Col><Col>{selectedShopData.EntryCode.Code}</Col>                        
                        </Row>                                        
                  </Modal.Body>
                  <Modal.Footer>
                    <Button className="QmeButton_" variant="secondary" type="button" shopguid={selectedShopData.Guid} onClick={editShopClick}><FaCog/></Button>    
                    <Button className="QmeButton_"  variant="primary" type="button" style={{backgroundColor:Branding().ButtonColor}} shopguid={selectedShopData.Guid} onClick={unLockShop}>Lås upp</Button>&nbsp;&nbsp;
                                          
                    {/* <Button variant="danger" onClick={initModal}>Close</Button> */}
                  </Modal.Footer>
                </Modal>



                <Container>
                    <Sida>                    
                        <MaterialReactTable  columns={columns} data={data.Shops} 
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            renderTopToolbarCustomActions={() => (<Rubrik>Butiker</Rubrik>)} initialState={initialState} onPaginationChange={setPagination} state={state} 
                                muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                                
                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        detailShopClick(event, row);
                                    },
                                    sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                })}

                        />                                            
                        <Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="submit"  onClick={addShopHandler}>Lägg till butik</Button>&nbsp;&nbsp;
                    </Sida>
                </Container>
            </ContentWrapper>            
        );
    } else {
        return (<Loading />);         
    }
}